import React from "react";

const InputFieldGroup = ({
  value = "",
  onChange = () => {},
  type = "text",
  classes = "",
  validationMessages = [],
  ...rest
}) => {
  const isInvalid = validationMessages.length > 0;
  const validationMessage = isInvalid ? validationMessages[0] : "";
  const borderColor = isInvalid ? { borderColor: "red" } : {};
  return (
    <>
      <input
        type={type}
        className={`${classes} form-control`}
        value={value}
        onChange={onChange}
        style={{ ...borderColor }}
        {...rest}
      />
      {validationMessage && (
        <span className="text_invalid fontSize-12" style={{ color: "red" }}>
          {validationMessage}
        </span>
      )}
    </>
  );
};

export default InputFieldGroup;
